import {Component} from "@angular/core";

@Component({
    selector: "pcg-ng-empty-list-view",
    template: require('./empty-search-result.html')
})
export class EmptySearchResultComponent {

}
